import React from 'react';
import { Images } from '../../assets';

/**
 * Simple navigation bar for public pages (login, signup, etc.)
 * Displays only the FAM logo
 */
const PublicNavBar = () => {
  return (
    <nav className="flex items-center justify-between px-6 py-4 bg-white border-b border-gray-200">
      <div className="flex items-center">
        <img 
          src={Images.famLogo} 
          alt="FAM" 
          className="h-8 w-auto"
        />
      </div>
    </nav>
  );
};

export default PublicNavBar;
